import {createSelector} from 'reselect';
import moment from 'moment'

const oits = state => state.oits.list;

const myAssignedOits = state => {
  let oits = state.oits.list;
  let fto = state.common.userContext;
  if(oits) {
    return oits.filter(oit => {
      return oit.trainingPhases.find(tf => {
        return tf.fto && tf.fto.ftoGuid === fto.userGuid;
      })
    });

  } else {
    return null
  }
};

const myTrainingProgram = state => state.myTrainingProgram.oit ? [state.myTrainingProgram.oit]: null;

const trainingProgramsStatsTotalWeeks = state => state.dashboard.trainingProgramsStatsTotalWeeks;

const findOpenedTrainingPhase = ({ trainingPhases }) =>
  trainingPhases ? trainingPhases.find(trainingPhase => trainingPhase.status === 'opened'): null;

const findPendingTrainingPhase = ({ trainingPhases }) =>
  trainingPhases ? trainingPhases.find(trainingPhase => trainingPhase.status === 'pending'): null;

const getPhaseIndex = (phase, trainingPhases) =>
  trainingPhases.findIndex(tp => tp.trainingPhaseGuid === phase.trainingPhaseGuid);

const getPhasePercentage = (trainingPhases) => {
  return Math.round(100 / trainingPhases.length);
};

const getPreviousProgress = (phase, trainingPhases) =>
  getPhaseIndex(phase, trainingPhases) * getPhasePercentage(trainingPhases);

const getTrainingPhaseProgress = (openPhase, trainingPhases) => getPreviousProgress(openPhase, trainingPhases);

const differenceFormDateTillToday = (date) => {
  const date1 = new Date(date);
  const date2 = new Date();
  const timeDiff = Math.abs(date2.getTime() - date1.getTime());
  const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
  return diffDays;
};

const getOpenPhaseProgress = (phase, trainingPhases) => {
  const daysActive = differenceFormDateTillToday(phase.openedAt);
  const daysActivePercentage = (daysActive / (phase.weeks * 7));
  const percentage = ((daysActivePercentage > 1 ? 1: daysActivePercentage)) * getPhasePercentage(trainingPhases);

  return Math.round(percentage);
};

const getTrainingFinishDate = (oit) => {
  let weeksCount = oit.trainingPhases.reduce((acc, tp) => acc + tp.weeks, 0);
  let startPhase = oit.trainingPhases
    .filter(tp => tp.openedAt)
    .sort((a, b) => (new Date(a.openedAt)).getTime() - (new Date(b.openedAt)).getTime())[0]

  if (startPhase) {
    let openedAt = moment(startPhase.openedAt);
    openedAt.add(weeksCount, "weeks");

    return openedAt
  }
  return null
}

// eslint-disable-next-line no-shadow
const getOitsProgressChart = (oits, totalWeeks) => {

  if (oits && totalWeeks) {
    const oitsProgress = oits
      .map((oit, index) => {
        let endsAt = getTrainingFinishDate(oit);

      if(!oit.trainingPhases || !oit.trainingTracker) {
        return {
          x: 0,
          y: oit.getFullName(),
          fullName: oit.getFullName(),
          color: '#e8cb92',
          guid: oit.guid,
          currentPhase: null,
          trainingPhases: oit.trainingPhases,
          trainingTracker: oit.trainingTracker,
          notStarted: true,
          active: oit.active,
          photo: oit.photo,
          endsAt
        }
      }

      const openPhase = findOpenedTrainingPhase(oit);

      if(!openPhase) {
        const pendingPhase = findPendingTrainingPhase(oit);
        if(pendingPhase) {

          const previousProgress = getTrainingPhaseProgress(pendingPhase, oit.trainingPhases);

          return {
            x: previousProgress,
            y: oit.getFullName(),
            fullName: oit.getFullName(),
            color: oit.trainingTracker.status === 'paused'? '#12a3b8': '#e8cb92',
            guid: oit.guid,
            currentPhase: openPhase,
            trainingPhases: oit.trainingPhases,
            status: oit.trainingTracker.status,
            trainingTracker: oit.trainingTracker,
            active: oit.active,
            photo: oit.photo,
            endsAt
          };
        }
      }

      if (openPhase) {
        const previousProgress = getTrainingPhaseProgress(openPhase, oit.trainingPhases);
        const openPhaseProgress = getOpenPhaseProgress(openPhase, oit.trainingPhases);

        return {
          x: previousProgress + openPhaseProgress,
          y: oit.getFullName(),
          fullName: oit.getFullName(),
          color: '#e8cb92',
          guid: oit.guid,
          currentPhase: openPhase,
          trainingPhases: oit.trainingPhases,
          status: oit.trainingTracker.status,
          trainingTracker: oit.trainingTracker,
          active: oit.active,
          photo: oit.photo,
          endsAt
        };
      }
      return {
        x: 100,
        y: oit.getFullName(),
        fullName: oit.getFullName(),
        guid: oit.guid,
        color: (oit.trainingTracker.status === 'terminated' || oit.trainingTracker.status === 'resigned') ? '#cc3642' : '#b1dcb3',
        trainingPhases: oit.trainingPhases,
        status: oit.trainingTracker.status,
        trainingTracker: oit.trainingTracker,
        active: oit.active,
        photo: oit.photo,
        completed: true,
        endsAt
      };
    });
    return oitsProgress;
  }
  return [];
};

const oitsProgressChart = createSelector(
  oits,
  trainingProgramsStatsTotalWeeks,
  getOitsProgressChart,
);

const myAssignedOitsChart = createSelector(
  myAssignedOits,
  trainingProgramsStatsTotalWeeks,
  getOitsProgressChart,
);

const myProgressChart = createSelector(
  myTrainingProgram,
  trainingProgramsStatsTotalWeeks,
  getOitsProgressChart
);

export default { oitsProgressChart, myProgressChart, myAssignedOitsChart };
